import { useLanguage } from "@/contexts/LanguageContext";
import { PRIVACY_POLICY_PATH } from "@shared/privacyPolicy";

export function PrivacyPolicyLinks() {
  const { t, isRtl } = useLanguage();
  return (
    <nav aria-label={t("Privacy information", "معلومات الخصوصية")} dir={isRtl ? "rtl" : "ltr"}
      className="border-t border-[#D4A843]/20 bg-[#FBF8F1] px-5 py-6 text-center text-sm text-[#665F59]">
      <a href={PRIVACY_POLICY_PATH} className="font-semibold text-[#8E671F] underline underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#A87822]">
        {t("Privacy Policy", "سياسة الخصوصية")}
      </a>
    </nav>
  );
}
